import * as $ from "jquery";
import Spinner from "./spinner";
import {toastAlert} from "./toastAlert";
import axios from "axios";
import proj4 from "proj4";
import {register} from "ol/proj/proj4";
import {get as getProjection} from "ol/proj";
import {handleValidationErrors, renderList} from "./forms";
import {GeoJSON} from "ol/format";

const PUWG_92_DEF = "+proj=tmerc +lat_0=0 +lon_0=19 +k=0.9993 +x_0=500000 +y_0=-5300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs";

export const handleShpForm = async (form) => {
    let spinner = new Spinner();
    form = $(form);

    let features = [];

    if(!window.fileLists['files[]'] || window.fileLists['files[]'].length < 4) {
        spinner.destroy();
        toastAlert('Musisz dodać pliki SHP, SHX, PRJ oraz DBF', {type: 'danger'});
        return;
    }

    let formData = new FormData();
    let index = 0;
    for (let file of window.fileLists['files[]']) {
        if(file.uploaded) {
            continue;
        }

        formData.append('files#' + index, file);
        index++;
    }

    if(form.find('select option').length) {
        formData.append('field', form.find('select').val())
    }

    try {
        let response = await axios.post(form.attr('action'), formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        let projection = null;
        if(response.data.shpData && response.data.shpData.prj) {
            try {
                // Sprawdzenie czy jest to projekcja PUWG_92
                if(response.data.shpData.prj.includes("PUWG_92")) {
                    // Użyj predefiniowanej projekcji PUWG_92
                    proj4.defs('PUWG_92', PUWG_92_DEF);
                    register(proj4);
                    projection = getProjection('PUWG_92');
                } else {
                    // Użyj projekcji z pliku PRJ dla innych przypadków
                    proj4.defs('CUSTOM', response.data.shpData.prj);
                    register(proj4);
                    projection = getProjection('CUSTOM');
                }
            } catch(projError) {
                console.error('Błąd podczas rejestracji projekcji:', projError);
                toastAlert('Problem z projekcją geograficzną. Używam domyślnej projekcji.', {type: 'warning'});
            }
        }

        if(response.data.code !== 200) {
            handleValidationErrors(response.data.errors);
        } else {
            for (let f of response.data.geojson.features) {
                let feature = (new GeoJSON()).readFeature(f, {
                    dataProjection: projection,
                    featureProjection: 'EPSG:3857'
                })

                features.push(feature)
            }

            window.fileLists['files[]'] = [];
            renderList(form.find('[name="files[]"]'))
            form.find('[data-app-file_container]').show();
        }
    } catch(err) {
        console.log('error', err)
        toastAlert('Wystąpił błąd podczas próby załadowania plików SHP.', {type: 'danger'});
    } finally {
        spinner.destroy()
    }

    return features;
}